import React, { useEffect, useRef, useState } from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import { Switch } from '@mui/material';
import axios from '../../api/PrivateApi'
import { Button } from '@mui/material';

const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
  background: theme.palette.background.default,
  marginTop: '20px'
}))

function RoleTable({ staffId }) {
  const [roleData, setRoleData] = useState([])
  const [switchStatus, setSwitchStatus] = useState([])

  const roleColumns = [
    {
      label: "Feature",
      name: "function",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Role Group",
      name: "role_group",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      label: "Enable/Disable",
      name: "enable_disable",
      options: {
        filter: false,
      },
    },
    {
      label: "Role Num",
      name: "role_num",
      options: {
        filter: false,
        display: false,
      },
    },
  ];
  const roleOptions = {
    customToolbarSelect: (selectedRow, displayData, setSelectedRow) => {
      const selected = selectedRow?.data.map((obj) => obj.dataIndex);
      const dataSelected = []
      selected.forEach((index) => {
        dataSelected.push(displayData[index])
      });
      return (
        <div>
          <Button style={{ margin: 7 }} onClick={() => multipleToggle(dataSelected, true)} variant='contained'>Enable Selected</Button>
          <Button style={{ margin: 7 }} onClick={() => multipleToggle(dataSelected, false)} variant='outlined' color='error'>Disable Selected</Button>
        </div>
      )
    }
  }

  const toggleSwitch = (role_nums, enable) => {
    let newStat = enable ? 'Active' : 'Inactive'
    const newSwitches = []
    role_nums.forEach(role => {
      let data = {}
      data[String(role)] = newStat
      newSwitches.push(data)
    });

    setSwitchStatus(prev => [...prev, ...newSwitches])
  }

  const onEnableDisableSwitchClick = async (event, role_num) => {
    let newStat = event.target.checked ? 'Active' : 'Inactive'
    const newSwitch = switchStatus.map(s => {
      if (Object.keys(s).includes(role_num)) {
        let data = {}
        data[String(role_num)] = newStat
        return data
      }
      return s
    })

    const res = await axios.post('roles/staffs/set', {
      role_num: role_num,
      staff_id: staffId,
      status: newStat
    })

    setSwitchStatus(newSwitch)
  }

  const multipleToggle = async (selected, enable) => {
    const roles_id = selected.map(value => value.data[3])
    let newStat = enable ? 'Active' : 'Inactive'

    const res = await axios.post('roles/staffs/setBulk', {
      role_nums: roles_id,
      staff_id: staffId,
      status: newStat
    })

    if (res.data.error.length < 1)
      toggleSwitch(roles_id, enable)
  }

  useEffect(() => {
    const fetchData = async () => {
      const roles = await axios.get(`roles/staffs/${staffId}`)
      const mySwitchStatus = roles.data[0].Role_Groups.map(role => {
        let data = {}
        data[String(role.role_num)] = role.Role_Staff.status
        return data
      })
      setSwitchStatus(mySwitchStatus)
    }
    fetchData()
  }, [staffId])

  useEffect(() => {
    const fetchData = async () => {

      const roles = await axios.get(`roles/staffs/${staffId}`)
      const myData = roles.data[0].Role_Groups.map(role => {
        let stat = 'Inactive'
        switchStatus.filter(s => {
          if (Object.keys(s).includes(String(role.role_num))) {

            stat = s[String(role.role_num)]
          }
          return stat
        })
        return { function: role.function, role_group: role.role_group, role_num: role.role_num, enable_disable: <Switch sx={{ color: 'primary' }} checked={stat === 'Active' ? true : false} onChange={(event) => onEnableDisableSwitchClick(event, role.role_num)} /> }
      })
      setRoleData(myData)
    }
    fetchData()
  }, [staffId, switchStatus])

  return (
    <StyledMUIDataTable
      title={"Roles"}
      data={roleData}
      columns={roleColumns}
      options={roleOptions}
    />
  )
}

export default RoleTable